<template>
  <div class="card">
    <header class="bandeau-modal card-header"></header>
    <div class="card-content">
      <section class="has-text-centered column is-12">
          <span class="is-size-3 has-text-weight-bold">
            {{ $t('listeCommandes.indexationMasse.title') }}
          </span>
      </section>
      <error-msg-component
          :messages="messagesError"
          :error="isError"
          :messagesChampsVide="messagesChampsVide"
          :champsVide="champsVide"
          :title="'addEditCivilite.error.problemOccurred'"
          :withEmplyFields="true"
          @close="isError = $event"/>
      <qd-message
        v-if="showForceIndexation"
        type="is-info"
        :title="$t('listeCommandes.indexationMasse.information')"
        :closable="false">
        <p>{{ $t('listeCommandes.indexationMasse.informationNotIndexable') }}</p>
        <p>{{ notIndexableCommandes }}</p>
      </qd-message>
      <qd-switch
        v-if="showForceIndexation"
        class="mgl-20px mgb-20px"
        v-model="payload.forceIndexation">
        {{ $t('listeCommandes.indexationMasse.forceIndexable') }}
      </qd-switch>
      <main>
        <div class="columns is-multiline mgb-3">
          <div class="column is-12 mg-0">
            <b-field
              :label="$t('listeCommandes.indexationMasse.nomIndice')"
              custom-class="has-text-default">
              <b-select
                v-model="indiceSelected"
                :disabled="indiceEtValeursLoad || hasCommandesIndice"
                expanded>
                <option :value="null">
                  {{ $t('editionCommande.indexation.personnalise') }}
                </option>
                <option
                  v-for="item in indiceEtValeurs"
                  :key="item.id"
                  :value="item">
                  {{ item.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div v-if="payload.forceIndexation" class="column pdh-0 is-6">
            <indexation-valeur
              :label="$t('listeCommandes.indexationMasse.indiceReference')"
              :date.sync="payload.dateIndexationReference"
              :valeur.sync="payload.valeurIndexationReference"
              :indiceSelected="indiceSelected"/>
          </div>
          <div :class="`column pdh-0 ${payload.forceIndexation ? 'is-6' : 'is-12'}`">
            <indexation-valeur
              :label="$t('listeCommandes.indexationMasse.indiceActuel')"
              :date.sync="payload.dateIndexationActuel"
              :valeur.sync="payload.valeurIndexationActuel"
              :indiceSelected="indiceSelected"
              @valuechanges="majDateIndexation"/>
          </div>
          <div class="column is-8">
            <b-field :label="$t('listeCommandes.indexationMasse.dateIndexation')">
              <b-datepicker
                v-model="payload.dateIndexation"
                icon="calendar-today"
                position="is-bottom-right"
                nearby-selectable-month-days
                show-week-number
                editable />
            </b-field>
          </div>
        </div>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
            @click="cancel()">
            {{ $t('general.popUpChangementCommercial.actions.cancel') }}
          </button>
          <button
            class="button is-addOrEdit has-text-centered mg-button-modal"
            :disabled="!hasCommandesWithSameIndice"
            @click="confirm()">
            {{ $t('general.popUpChangementCommercial.actions.valider') }}
          </button>
        </div>
      </main>
    </div>
    <b-modal v-model="showConfirmation" has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('listeCommandes.indexationMasse.messageConfirmation')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="showConfirmation = false"
        @yes="indexerCommandes">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import indexationValeur from '@/components/baux/contrat/componentEdition/indexationValeur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import cloneDeep from 'lodash/cloneDeep';
import { getAll } from '@/api/indiceEtValeur/';
import { indexation } from '@/api/commande/index';
import translate from '@/services/devisCommandes/validation/indexationCommandeTranslator';
import validation from '@/services/devisCommandes/validation/validationIndexationCommande';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import formatDateIso from '@/services/general/formatIsoDate';
import validationGeneral from '@/services/validation/validation';
import popUpPrevention from '@/components/general/popUpPrevention';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'popUpIndexationMasse',
  components: {
    indexationValeur,
    errorMsgComponent,
    popUpPrevention,
  },
  props: {
    elementsSelectionnes: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      showConfirmation: false,
      forceIndexable: false,
      indiceEtValeurs: [],
      indiceSelected: null,
      indiceEtValeursLoad: false,
      isError: false,
      messagesChampsVide: [],
      champsVide: [],
      messagesError: [],
      payload: {
        typesProduits: [],
        dateIndexation: new Date(),
        valeurIndexationActuel: null,
        dateIndexationActuel: null,
        valeurIndexationReference: null,
        dateIndexationReference: null,
        forceIndexation: false,
        indiceReferenceId: null,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    showForceIndexation() {
      return this.elementsSelectionnes.some(commande => !commande.estIndexable);
    },
    notIndexableCommandes() {
      return this.elementsSelectionnes
        .filter(commande => !commande.estIndexable)
        .map(commande => commande.code)
        .join(', ');
    },
    hasCommandesIndice() {
      return this.elementsSelectionnes.some(commande => commande.indiceReferenceId);
    },
    hasCommandesWithSameIndice() {
      return this.elementsSelectionnes.every(commande => {
        return commande.indiceReferenceId === null
          || commande.indiceReferenceId === this.indiceSelected.id;
      });
    },
  },
  methods: {
    async indexerCommandes() {
      this.isError = false;
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.messagesError = [];
      const loadingComponent = this.$buefy.loading.open();
      const payload = cloneDeep(this.payload);
      payload.dateIndexation = formatDateIso(payload.dateIndexation);
      payload.dateIndexationActuel = formatDateIso(payload.dateIndexationActuel);
      if (payload.dateIndexationReference) {
        payload.dateIndexationReference = formatDateIso(payload.dateIndexationReference);
      }
      payload.indiceReferenceId = this.indiceSelected?.id;
      this.showConfirmation = false;
      try {
        await indexation({
          commandeIds: this.elementsSelectionnes.map(commande => commande.id),
          indexationInput: payload,
        });
        messageSucces(this.$t('detailCommande.indexation.successIndexationMasseMsg'));
        this.$emit('done');
        this.$parent.close();
      } catch (e) {
        this.isError = true;
        if (e.response && e.response.data && e.response.data.error) {
          validation(e.response, this.messagesError);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesError, this.messagesChampsVide, translate);
          this.affichageMessagesErreur = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async getIndiceEtValeur() {
      this.indiceEtValeursLoad = true;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const { items } = (await getAll({ limit: NO_PAGINATION })).data.result;
        this.indiceEtValeurs = items;
        this.indiceEtValeurs.forEach(indice => {
          indice.indiceValeurs.sort((a, b) => a.dateReference < b.dateReference);
        });
        const commande = this.elementsSelectionnes.find(c => c.indiceReferenceId);
        const findIndice = this.indiceEtValeurs
          .find(el => el.id === commande?.indiceReferenceId);
        if (findIndice) this.indiceSelected = findIndice;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      } finally {
        this.indiceEtValeursLoad = false;
      }
    },
    initialisationPayload() {
      this.payload.typesProduits = this.societeActive.produitsIndexable;
    },
    confirm() {
      this.showConfirmation = true;
    },
    cancel() {
      this.$parent.close();
    },
    majDateIndexation() {
      this.payload.dateIndexation = this.payload.dateIndexationActuel;
    },
  },
  async mounted() {
    this.initialisationPayload();
    await this.getIndiceEtValeur();
    if (this.hasCommandesIndice) {
      if (!this.hasCommandesWithSameIndice) {
        this.isError = true;
        this.messagesError.push({
          message: 'validationCommande.indexation.commandeWithDifferentIndice',
          parametres: {
            codes: this.elementsSelectionnes
              .filter(cmd => !!cmd.indiceReferenceId
                  && cmd.indiceReferenceId !== this.indiceSelected?.id)
              .map(cmd => cmd.code)
              .join(', '),
          },
        });
      }
    }
  },
};
</script>
